class AlbumBulkArtistSelector {
  init() {
    const composerSelect = document.querySelector('[data-album-composer-select]');
    if (!composerSelect) {
      return;
    }

    const form = composerSelect.closest('form') || document;
    const sync = () => this.syncArtistOptions(form, composerSelect.value);
    composerSelect.addEventListener('change', sync);
    sync();

    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(sync);
      observer.observe(form, { childList: true, subtree: true });
    }
  }

  syncArtistOptions(form, composerId) {
    form.querySelectorAll('[data-album-bulk-artist-select]').forEach((select) => {
      Array.from(select.options).forEach((option) => {
        const optionComposerId = option.dataset.composerId;
        const visible = !optionComposerId || !composerId || optionComposerId === composerId;
        option.hidden = !visible;
      });

      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.hidden) {
        select.value = '';
      }
    });
  }
}

export default AlbumBulkArtistSelector;
